export default __webpack_public_path__ + "static/media/GlobalGivingCausesThumb.d49ca408.png";